import { accordion } from "./_accordion";
import { animation } from "./_animation";
import { countUp } from "./_countUp";
import { common } from "./_common";
import { drawer } from "./_drawer";
import { slide } from "./_slide";
import { test } from "./_test";
import { tab } from "./_tab";

accordion();
animation();
countUp();
common();3
drawer();
slide();
// test();
// tab();